import { gql } from "@apollo/client";

export const SEARCH_PLAYERS_QUERY = gql`
    query SearchPlayers($searchQuery: String, $limit: Int) {
        searchPlayers(searchQuery: $searchQuery, limit: $limit) {
            id
            userId
            name
            nickname
        }
    }
`;
